/* eslint-disable eslint-comments/disable-enable-pair -- Legacy */
/* eslint-disable no-shadow -- Legacy */

import { getMyEnv } from '@lessonnine/my.js'

// eslint-disable-next-line perfectionist/sort-imports -- process is a global
import process from 'process'
import { getSubdomainFromLocale } from 'src/dataLayer/localData/languageCodes'
import { getRawQueryString, getReturnToUrl } from 'src/dataLayer/localData/queryParams'
import { getZendeskLocale } from 'src/dataLayer/localData/zendeskConfig'

import interpolate from './helpers/interpolate'

const {
  apigatewayBaseUrl,
  assetUrl,
  awsSessionEndpoint,
  awsSessionMethod,
  environment,
  homeBaseUrl,
  locale,
  myBaseUrl,
  platform,
  rollbarAccessToken,
  signInUrl,
  staticBaseUrlTemplate,
  uuid,
} = getMyEnv()

// User Data
const UUID = uuid
// TODO: Always get locale from here instead of useRouteParamsContext hook
const LOCALE = locale
const ROLLBAR_ACCESS_TOKEN = rollbarAccessToken

// Env
const RUNTIME_ENVIRONMENT = environment
const ROLLBAR_ENVIRONMENT = platform ? `${environment}-${platform}` : environment
const isPrivateEnv = () => new Set(['development', 'test', undefined]).has(environment)

// URLs
const ASSET_URL = assetUrl
const APIGATEWAY_BASE_URL = apigatewayBaseUrl
const DASHBOARD_URL = `${myBaseUrl}/dashboard`
const TRACKING_URL = `${APIGATEWAY_BASE_URL}/v1/events`
const ROLLBAR_API_URL = 'https://api.rollbar.com/api/1/item/'
const SIGN_IN_URL = signInUrl
const AWS_SESSION_ENDPOINT = awsSessionEndpoint
const AWS_SESSION_METHOD = awsSessionMethod

const OAUTH_SIGNUP_URL_TEMPLATE =
  // eslint-disable-next-line no-useless-concat -- we need to concatenate the strings
  `${homeBaseUrl}/%{locale}/` + 'oauth_session/new?provider=%{provider}&return_to=%{returnTo}'
const faqURLTemplate =
  'https://support.babbel.com/hc/%{locale}/categories/200333238-Frequently-asked-questions'

const getRegistrationOrigin = (location) =>
  location?.hostname?.startsWith('start.') ? location.origin : myBaseUrl

// skipcq: JS-0123 - can be refactored separately
const getRegistrationUrl = (locale, queryParameters, location = globalThis.location) => {
  const hasB2BInvitationToken = Boolean(queryParameters?.has('invitation_token'))
  return `${getRegistrationOrigin(location)}/${locale}/onboarding/${hasB2BInvitationToken ? 'default_b2b' : 'default'}/0${getRawQueryString()}`
}

// skipcq: JS-0123 - can be refactored separately
const getIndexPageURL = (locale) =>
  interpolate(staticBaseUrlTemplate, {
    subdomain: getSubdomainFromLocale(locale),
  })

// skipcq: JS-0123 - can be refactored separately
const getOauthSignupURL = (locale, provider) =>
  interpolate(OAUTH_SIGNUP_URL_TEMPLATE, {
    locale,
    provider,
    returnTo: getReturnToUrl(globalThis.location.search),
  })

// skipcq: JS-0123 - can be refactored separately
const getBusinessSuccessPageURL = (locale, environment) =>
  `${myBaseUrl}/${locale}/${environment}/login-mobile/business/success`

const getFAQURL = () => interpolate(faqURLTemplate, { locale: getZendeskLocale() })

// Buildtime
const { BABBEL_APP_VERSION } = process.env
// TODO: needs to be exposed via repositories.terraform
const { BEARER_TOKEN } = process.env

const environmentConfigElement = document.querySelector('[data-config]')
let environmentConfig

if (environmentConfigElement) {
  environmentConfig = JSON.parse(environmentConfigElement.textContent ?? '')
}
const { context } = environmentConfig || {}

export {
  APIGATEWAY_BASE_URL,
  ASSET_URL,
  AWS_SESSION_ENDPOINT,
  AWS_SESSION_METHOD,
  BABBEL_APP_VERSION,
  BEARER_TOKEN,
  context,
  DASHBOARD_URL,
  getBusinessSuccessPageURL,
  getFAQURL,
  getIndexPageURL,
  getOauthSignupURL,
  getRegistrationUrl,
  isPrivateEnv,
  LOCALE,
  ROLLBAR_ACCESS_TOKEN,
  ROLLBAR_API_URL,
  ROLLBAR_ENVIRONMENT,
  RUNTIME_ENVIRONMENT,
  SIGN_IN_URL,
  TRACKING_URL,
  UUID,
}
